export default {
  DATE_FORMAT: 'DD/MM/YYYY',
  YEAR_FORMAT: 'YYYY',
  TIME_FORMAT: 'HH:mm',
  TIME_IN_SECOND_FORMAT: 'HH:mm:ss',
  MINUTES_AND_SECONDS: 'mm:ss',
  YEAR_FORMAT: 'YYYY',
};
